import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpService } from '../http.service';
import { ElectronService } from '../../electron.service';
import { CreatePowerBIBookmarkDetail, PowerBIBookmark } from '../../_objects/analytics-powerbi-bookmark';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsOnlineService extends HttpService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    ) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  createBookmark(bookmark: CreatePowerBIBookmarkDetail): Observable<PowerBIBookmark> {
    const endpoint = super.getEndpoint('bookmarks');

    return this.http.post<PowerBIBookmark>(endpoint, bookmark,
      {  withCredentials: super.getWithCredentialsOption() });

  }

  getBookmarks(): Observable<PowerBIBookmark[]> {
    const endpoint = super.getEndpoint('bookmarks');

    return this.http.get<PowerBIBookmark[]>(endpoint,
      {  withCredentials: super.getWithCredentialsOption() });

  }

  deleteBookmark(bookmarkId: string): Observable<void> {
    const endpoint = super.getEndpoint('bookmarks', bookmarkId);

    return this.http.delete<void>(endpoint,
      {  withCredentials: super.getWithCredentialsOption() });

  }
}
